import { createIconComponent } from '../../factory/create-icon-component';
export const ArrowUpDownIcon = createIconComponent(
  'ArrowUpDownIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.16644 16.9442L7.05552 20.8331M7.05552 20.8331L10.9445 16.9442M7.05552 20.8331V8.38843"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4445 6.05511L17.3334 2.16614M17.3334 2.16614L21.2224 6.05511M17.3334 2.16614V14.6108"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
